export default __webpack_public_path__ + "static/media/intel.fb0287ff.png";